import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom"; // needed for ReactDOMServer to function
import ReactDOMServer from "react-dom/server";
import _ from "lodash";
import api from "../../utils/api";
import { _getCSRFTokenValue, _getTranslation } from "../../utils/helper";

import { Loader, RatingStars } from "../../atoms";
import { InputText, InputRating } from "../../forms";

const PublicationFeedback = (props) => {
  const [values, setValues] = useState({
    publication_id: "",
    publication_title: "",
    publication_url: "",
    name: "",
    email_address: "",
    organization: "",
    feedback: "",
    rating: 3,
  });
  const [pubData, setPubData] = useState({
    publication_id: "",
    publication_title: "",
    publication_subtitle: "",
    publication_image: "",
    publication_url: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (props?.data) {
      const saveData = {
        publication_id: props?.data?.id ? parseInt(props?.data?.id) : "",
        publication_title: !_.isEmpty(props?.data?.title)
          ? JSON.parse(props?.data?.title)
          : "",
        publication_url: props?.data?.url,
      };

      setValues({
        ...values,
        ...saveData,
      });

      setPubData({
        ...saveData,
        publication_subtitle: !_.isEmpty(props?.data?.subtitle)
          ? JSON.parse(props?.data?.subtitle)
          : "",
        publication_image: props?.data?.image,
      });
    }
  }, [props?.data]);

  useEffect(() => {
    // update rating on the DOM
    const pubRatingElements = document.querySelectorAll(".publication-rating");
    if (pubRatingElements.length > 0 && response?.rating) {
      pubRatingElements.forEach((element, idx) => {
        const ratingString = ReactDOMServer.renderToString(
          <RatingStars currentRating={response?.rating} />
        );
        element.innerHTML = ratingString;
      });
    }
  }, [response?.rating]);

  const handleSubmission = async () => {
    setIsLoading(true);
    setErrors({});
    setResponse(null);

    const csrfToken = await _getCSRFTokenValue();
    api
      .post("/form/publicationfeedback/submit", values, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setIsLoading(false);
        setResponse(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.data?.errors) {
          setErrors(err.data.errors);
        } else {
          setErrors({
            general_error: ["Something went wrong, please try again."],
          });
        }
      });
  };

  return (
    <React.Fragment>
      <div className="p-6 sm:p-8 lg:px-12">
        <h2 className="h2">{_getTranslation("submit_feedback")}</h2>
        <div className="text-mobileS md:text-desktopS">
          {_getTranslation("for_the_following_publication")}:
        </div>
      </div>

      <div className="bg-ideaBackgroundGrey100 p-6 sm:py-4 sm:px-8 lg:px-12 sm:mb-4 flex flex-col sm:flex-row sm:items-center gap-y-4 gap-x-8">
        <div className="w-[130px] sm:translate-y-[1rem] sm:-mb-8">
          {pubData.publication_image && (
            <img
              src={pubData.publication_image}
              alt=""
              className="w-full rounded"
            />
          )}
        </div>
        <div className="flex-1">
          <h3 className="h3 !mb-1">{pubData.publication_title}</h3>
          <div className="text-mobileM md:text-desktopM">
            {pubData.publication_subtitle}
          </div>
        </div>
      </div>

      <div className="p-6 sm:p-8 lg:px-12">
        {response?.message && _.isString(response.message) ? (
          <p className="font-bold">{response.message}</p>
        ) : (
          <React.Fragment>
            <InputText
              label={`${_getTranslation("name")}*`}
              value={values.name}
              onChange={(e) => {
                setValues({ ...values, name: e.target.value });
              }}
              error={_.get(errors, "name[0]")}
            />
            <InputText
              label={`${_getTranslation("email")}*`}
              type="email"
              value={values.email_address}
              onChange={(e) => {
                setValues({ ...values, email_address: e.target.value });
              }}
              error={_.get(errors, "email_address[0]")}
            />
            <InputText
              label={_getTranslation("organization")}
              value={values.organization}
              onChange={(e) => {
                setValues({ ...values, organization: e.target.value });
              }}
              error={_.get(errors, "organization[0]")}
            />
            <InputText
              label={`${_getTranslation("feedback")}*`}
              type="textarea"
              value={values.feedback}
              onChange={(e) => {
                setValues({ ...values, feedback: e.target.value });
              }}
              error={_.get(errors, "feedback[0]")}
            />

            <p className="text-mobileXS md:text-desktopXS">
              {_getTranslation("what_did_you_think_of_this_publication")}
            </p>

            <InputRating
              label={_getTranslation("rate_this_publication_5_is_highest")}
              value={values.rating}
              onChange={(value) => {
                setValues({ ...values, rating: value });
              }}
              error={_.get(errors, "rating[0]")}
            />

            {_.get(errors, "general_error[0]") && (
              <div className="text-red-500 font-bold mt-8">
                {_.get(errors, "general_error[0]")}
              </div>
            )}

            <div className="flex items-center gap-x-4 mt-8">
              <button
                className="btn btn-s--pill"
                onClick={() => handleSubmission()}
              >
                {_getTranslation("submit_feedback")}
              </button>
              {isLoading && <Loader />}
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default PublicationFeedback;
